import HTTP from "@/_helpers/http";
import { MAM__API } from "@/_helpers/urls";
import { MAM__MUTATIONS } from "../mutation-types";
import { MAM__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    mamlists: [],
    pammLists: [],
    copyTradeLists: [],
    mammonthlytrades: [],
    mamweeklytrades: [],
    toptradesbysymbol: [],
    managerprofitloss: [],
    managerInvestorLiveOrders: [],
    managerInvestorreports: [],
    mammanagerstatistics: null,
    mammanagerinvestors: null,
    commissions: null,
    commissionshistories: null,
    isLoading: false,
    pagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [MAM__MUTATIONS.GETALLMAM](state, data) {
        state.mamlists = data.data;
        state.pagination = {
            total: data.total,
            perPage: data.perPage,
            currentPage: data.page,
            lastPage: data.lastPage
        };
    },
    [MAM__MUTATIONS.GETALLPAMM](state, data) {
        state.pammLists = data?.data?.pamms;
        state.pagination = data?.data?.pagination;
    },
    [MAM__MUTATIONS.GETALLCOPYTRADE](state, data) {
        state.copyTradeLists = data?.data?.pamms;
        state.pagination = data?.data?.pagination;
    },
    [MAM__MUTATIONS.GETMONTHLYTRADES](state, data) {
        state.mammonthlytrades = data;
    },
    [MAM__MUTATIONS.GETWEEKLYTRADES](state, data) {
        state.mamweeklytrades = data;
    },
    [MAM__MUTATIONS.GETTOPTRADESBYSYMBOL](state, data) {
        state.toptradesbysymbol = data;
    },
    [MAM__MUTATIONS.GETMANAGERPROFITLOSS](state, data) {
        state.managerprofitloss = data;
    },
    [MAM__MUTATIONS.GETMAMMANAGERSTATISTICS](state, data) {
        state.mammanagerstatistics = data;
    },
    [MAM__MUTATIONS.GETMAMMANAGERINVESTORS](state, data) {
        state.mammanagerinvestors = data;
    },
    [MAM__MUTATIONS.GETLIVEORDERS](state, data) {
        state.managerInvestorLiveOrders = data;
    },
    [MAM__MUTATIONS.GETREPORTS](state, data) {
        state.managerInvestorreports = data;
    },
    [MAM__MUTATIONS.COMMISSIONSTAB](state, data) {
        state.commissions = data;
    },
    [MAM__MUTATIONS.COMMISSIONSHISTORYTAB](state, data) {
        state.commissionshistories = data;
    },
    SET_LOADING(state, data) {
        state.isLoading = data;
    },
};
// Actions
const actions = {
    async [MAM__ACTIONS.COMMISSIONSHISTORYTAB]({ commit, state }, parameter) {
        try {
            const idParam =
                parameter?.account != null ? `account=${parameter.account}` : "";

            const startTimeParam =
                parameter?.startTime != null ? `startTime=${parameter.startTime}` : "";

            const endTimeParam =
                parameter?.endTime != null ? `endTime=${parameter.endTime}` : "";

            const parameterString = [idParam, startTimeParam, endTimeParam]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().get(
                MAM__API.COMMISSIONSHISTORYTAB +
                (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                commit(MAM__MUTATIONS.COMMISSIONSHISTORYTAB, response.data);
            } else {
                commit(MAM__MUTATIONS.COMMISSIONSHISTORYTAB, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.UPDATEINVESTORCOMMISSION]({ commit, state }, data) {
        try {
            const url = `${MAM__API.UPDATEINVESTORCOMMISSION}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success('Successfully approved')
            }
        } catch (error) {
            console.log(error);
            toast.success(error.response.data.message || "Failed to approve")
        }
    },
    async [MAM__ACTIONS.COMMISSIONSTAB]({ commit, state }, id) {
        try {
            const url = `${MAM__API.COMMISSIONSTAB}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.COMMISSIONSTAB, response.data);
            } else {
                commit(MAM__MUTATIONS.COMMISSIONSTAB, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETREPORTS]({ commit, state }, account) {
        try {
            const url = `${MAM__API.GETREPORTS}/${account}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETREPORTS, response.data);
            } else {
                commit(MAM__MUTATIONS.GETREPORTS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETLIVEORDERS]({ commit, state }, account) {
        try {
            const url = `${MAM__API.GETLIVEORDERS}/${account}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETLIVEORDERS, response.data);
            } else {
                commit(MAM__MUTATIONS.GETLIVEORDERS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
     async [MAM__ACTIONS.GETMAMMANAGERINVESTORS]({ commit, state }, account) {
        commit("SET_LOADING", true);
        try {
            const url = `${MAM__API.GETMAMMANAGERINVESTORS}/${account}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                const data = response.data;
                if (data && data.transformedInvestors) {
                    data.transformedInvestors.forEach(investor => {
                        // investor.name = `${investor.fname} ${investor.lname}`;
                        investor.balance = parseFloat(investor.balance).toFixed(2);
                        investor.equity = parseFloat(investor.equity).toFixed(2);
                        investor.margin = parseFloat(investor.margin).toFixed(2);
                    });
                }
                commit(MAM__MUTATIONS.GETMAMMANAGERINVESTORS, data);
            } else {
                commit(MAM__MUTATIONS.GETMAMMANAGERINVESTORS, []);
            }
        } catch (error) {
            console.log(error);
        } finally {
            commit("SET_LOADING", false);
        }
    },
    async [MAM__ACTIONS.REMOVEINVESTOR]({ dispatch }, parameter) {
        try {
            const url = `${MAM__API.REMOVEINVESTOR}`;
            const response = await HTTP().post(url, parameter);

            if (response.status === 200) {
                dispatch(MAM__ACTIONS.GETMAMMANAGERINVESTORS, parameter.manager_account)
                dispatch(MAM__ACTIONS.GETMAMMANAGERSTATISTICS, parameter.manager_account)
                toast.success(response.data.message)
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error('Failed to remove')
        }
    },
    async [MAM__ACTIONS.CHANGEMANAGERSTATUS]({ dispatch }, parameter) {
        try {
            const url = `${MAM__API.CHANGEMANAGERSTATUS}`;
            const response = await HTTP().post(url, parameter);

            if (response.status === 200) {
                dispatch(MAM__ACTIONS.GETALLMAM)
                dispatch(MAM__ACTIONS.GETALLPAMM)
                toast.success(response.data.message)
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error('Failed to update')
        }
    },
    async [MAM__ACTIONS.CHANGEINVESTORSTATUS]({ dispatch }, parameter) {
        try {
            const url = `${MAM__API.CHANGEINVESTORSTATUS}`;
            const response = await HTTP().post(url, parameter);

            if (response.status === 200) {
                dispatch(MAM__ACTIONS.GETMAMMANAGERINVESTORS, parameter.manager_account)
                dispatch(MAM__ACTIONS.GETMAMMANAGERSTATISTICS, parameter.manager_account)
                toast.success(response.data.message)
                return;
            }
        } catch (error) {
            console.log(error);
            toast.error('Failed to update')
        }
    },
    async [MAM__ACTIONS.GETMAMMANAGERSTATISTICS]({ commit, state }, account) {
        try {
            const url = `${MAM__API.GETMAMMANAGERSTATISTICS}/${account}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETMAMMANAGERSTATISTICS, response.data);
            } else {
                commit(MAM__MUTATIONS.GETMAMMANAGERSTATISTICS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETMANAGERPROFITLOSS]({ commit, state }, parameter) {
        try {
            const url = `${MAM__API.GETMANAGERPROFITLOSS}/${parameter.account}/${parameter.period}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETMANAGERPROFITLOSS, response.data);
            } else {
                commit(MAM__MUTATIONS.GETMANAGERPROFITLOSS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETTOPTRADESBYSYMBOL]({ commit, state }, account_no) {
        try {
            const url = `${MAM__API.GETTOPTRADESBYSYMBOL}/${account_no}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETTOPTRADESBYSYMBOL, response.data);
            } else {
                commit(MAM__MUTATIONS.GETTOPTRADESBYSYMBOL, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETMONTHLYTRADES]({ commit, state }, account_no) {
        try {
            const url = `${MAM__API.GETMONTHLYTRADES}/${account_no}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETMONTHLYTRADES, response.data);
            } else {
                commit(MAM__MUTATIONS.GETMONTHLYTRADES, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETWEEKLYTRADES]({ commit, state }, account_no) {
        try {
            const url = `${MAM__API.GETWEEKLYTRADES}/${account_no}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(MAM__MUTATIONS.GETWEEKLYTRADES, response.data);
            } else {
                commit(MAM__MUTATIONS.GETWEEKLYTRADES, []);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETALLMAM]({ commit, state }, parameter = {}) {
        try {
            commit("SET_LOADING", true);

            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${MAM__API.GETALLMAM}${queryParams ? `?${queryParams}` : ''}`
            );

            commit(MAM__MUTATIONS.GETALLMAM, response.data);
            commit("SET_LOADING", false);
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETALLPAMM]({ commit, state }, parameter = {}) {
        try {
            commit("SET_LOADING", true);

            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const url = `${MAM__API.GETALLPAMM}`;
            const response = await HTTP().get(
                `${url}${queryParams ? `?${queryParams}` : ''}`
            );

            commit(MAM__MUTATIONS.GETALLPAMM, response.data);
            commit("SET_LOADING", false);
        } catch (error) {
            console.log(error);
        }
    },
    async [MAM__ACTIONS.GETALLCOPYTRADE]({ commit, state }, parameter = {}) {
        try {
            commit("SET_LOADING", true);

            const {
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search })
            }).toString();

            const url = `${MAM__API.GETALLCOPYTRADE}`;
            const response = await HTTP().get(
                `${url}${queryParams ? `?${queryParams}` : ''}`
            );

            commit(MAM__MUTATIONS.GETALLCOPYTRADE, response.data);
            commit("SET_LOADING", false);
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
